jQuery.importStyle = function(url) {
    if (!$(`link[href="${url}"]`).length) {
        $('<link>').appendTo('head').attr({
            type: "text/css",
            rel: "stylesheet",
            href: url
        });
    }
};